import personnelDisputeFA from './fa/fa.json'

const PersonnelDisputeMessages = {
  fa: { ...personnelDisputeFA },
}

export default PersonnelDisputeMessages
